var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg360TradeHub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1341.79 848.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1d1d1b;}.cls-2{fill:#ff5148;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:#cc3323;}.cls-5{fill:url(#linear-gradient-2);}.cls-6{fill:#f8b617;}.cls-7{fill:url(#linear-gradient-3);}.cls-8{fill:#757478;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 778.41,
    y1: 358.72,
    x2: 896.7,
    y2: 416.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ff5148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8b617"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 730.38,
    y1: 457.71,
    x2: 848.68,
    y2: 515.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 778.41,
    y1: 358.72,
    x2: 896.71,
    y2: 416.11,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M734.57,525.29A41.76,41.76,0,0,1,705,454L901.76,257.28a41.76,41.76,0,0,1,59.06,59.06L764.11,513.06A41.63,41.63,0,0,1,734.57,525.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M805,34.72a41.64,41.64,0,0,1-7.07,31.17l-.37.52-249,266.9a41.76,41.76,0,0,1-68.19-48.24L729.7,17.65A41.77,41.77,0,0,1,805,34.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M636.21,566a180.87,180.87,0,1,1,127.9-308.76l68.82,68.83,68.83-68.83a180.87,180.87,0,0,1,255.78,0c70.52,70.52,70.52,185.27,0,255.79s-185.27,70.52-255.79,0l-.63-.65-68.19-68.19-68.82,68.83A179.69,179.69,0,0,1,636.21,566ZM961.35,454.53a97.34,97.34,0,1,0-.53-138.18L892,385.17,960.82,454ZM636.21,287.84A97.34,97.34,0,1,0,705,454l68.83-68.83L705,316.35A96.69,96.69,0,0,0,636.21,287.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M764.11,513.06,705,454,901.76,257.28a41.76,41.76,0,0,1,59.06,59.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M734.57,525.29A41.76,41.76,0,0,1,705,454l32-32A41.77,41.77,0,1,1,796.13,481l-32,32A41.63,41.63,0,0,1,734.57,525.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M917,351.07c-9.32,0-18.64-4.13-25.76-12.38-14.22-16.5-14.22-43.24,0-59.74l27.93-32.39c14.22-16.5,37.28-16.5,51.5,0s14.22,43.24,0,59.74l-27.92,32.39C935.61,346.94,926.29,351.07,917,351.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M931.28,525.3a41.62,41.62,0,0,1-29.53-12.24c-.15-.14-.29-.3-.44-.45L705,316.35a41.77,41.77,0,0,1,59.07-59.07L960.82,454a41.77,41.77,0,0,1-29.54,71.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348.81,575.48A179.41,179.41,0,0,1,183.36,465.69l71.67-29A101.83,101.83,0,0,0,349.57,500a103.69,103.69,0,0,0,0-207.38H319.84l-16-61,96.83-102.17h-125l-16.78,19.06H199.38V53.21H511.21v72.43L412.86,227.81c67.85,25.92,115.89,91.49,115.89,167.73A179.78,179.78,0,0,1,348.81,575.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1006.17,326l-172,52.24,77.7-162.31c0,.29.07.58.1.87a126.77,126.77,0,0,0,93.37,109Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M62.1,661v40.62h39.46V732H61.81v61.81c0,13.64,7.54,20.31,18.57,20.31a40.46,40.46,0,0,0,17.12-4.35L107.37,840a79.35,79.35,0,0,1-29.31,6.1C47,847.25,26.7,829.55,26.7,793.85V732H0V701.57H26.7V664.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M160.76,701.28l2.61,16.54c11-17.7,25.83-20.31,40.33-20.31,14.8,0,29,5.8,36.86,13.64l-16,30.76c-7.26-6.09-13.93-9.29-25.54-9.29-18.57,0-35.69,9.87-35.69,36.28v75.44H128V701.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M367.37,701.28h33.95V844.34H368l-1.74-20.89c-8.13,16.83-30.47,25-46.43,25.25-42.37.29-73.71-25.83-73.71-76,0-49.33,32.79-75.16,74.58-74.87,19.15,0,37.43,9,45.56,23.21Zm-85.9,71.39c0,27.28,18.86,43.53,42.37,43.53,55.71,0,55.71-86.77,0-86.77C300.33,729.43,281.47,745.39,281.47,772.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M579.78,641.5V844.34H546.7l-2.32-19.73c-11,17.12-28.73,22.93-46.14,22.93-42.08,0-73.71-27.86-73.71-74.87,0-49.33,31.05-74.87,72.84-74.87,15.09,0,38.59,8.13,47,22.93V641.5ZM459.93,772.67c0,25,18,42.07,40.63,42.07,22.34,0,41.5-16.24,41.5-42.07,0-25-19.16-41.79-41.5-41.79C477.92,730.88,459.93,746.84,459.93,772.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M643.9,785.44c2.32,17.7,17.7,30.47,42.66,30.47,13.06,0,30.18-4.94,38.3-13.35L747.5,824.9c-15.09,15.67-39.76,23.22-61.52,23.22-49.33,0-78.64-30.47-78.64-76.32,0-43.53,29.6-74.87,76-74.87,47.88,0,77.77,29.6,72.25,88.51Zm77.77-29.31c-2.32-18.57-16.83-27.86-37.14-27.86-19.15,0-34.82,9.29-40,27.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M815.4,641.22v79.51c12.77-16.55,28.44-21.48,44.69-21.48,40.62,0,58.62,27.57,58.62,69.65v75.44H883.3V769.19c0-26.12-13.64-37.15-32.5-37.15-20.89,0-35.4,17.7-35.4,39.18v73.12H780V641.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M982,701.28v74.87c0,21.76,11.89,38.31,34.53,38.31,21.76,0,36.56-18.29,36.56-40.05V701.28h35.11V844.63h-31.63l-2.32-19.44c-14.8,14.51-28.44,21.47-48.46,21.47-34.24,0-59.2-25.82-59.2-70.22V701.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1154.92,641.5v79.23c8.41-14.8,31.92-22.93,47-22.93,41.78,0,72.83,25.54,72.83,74.87,0,47-31.63,74.87-73.7,74.87-17.42,0-35.12-5.81-46.14-22.93l-2.33,19.73h-33.08V641.5Zm2.32,131.17c0,25.83,19.15,42.07,41.49,42.07,22.64,0,40.63-17.12,40.63-42.07,0-25.83-18-41.79-40.63-41.79C1176.39,730.88,1157.24,747.71,1157.24,772.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1341.79,826.06c0,27.57-41.78,27.57-41.78,0S1341.79,798.5,1341.79,826.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M892,267s31.47-35,61-45.79c0,0,28.49-13,49.5-14.93L988.73,276.9l-41.49,20.16Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg360TradeHub);
export default __webpack_public_path__ + "static/media/360TradeHub.44af6bc8bdbe50864ab1b66b1cd30b7e.svg";
export { ForwardRef as ReactComponent };